import React from 'react';
// "Publication Details Few slots left"
const ThirdStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    registration_link,
    paper_title,
    journals,
    isbn_number,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>
        Your paper, “{paper_title ? paper_title : `[Paper Title]`},” has been
        accepted for publication in one of the following{' '}
        <strong> Scopus/WoS indexed journals</strong> as part of{' '}
        {conference_short_name
          ? conference_short_name
          : '[Conference Short Name]'}
        , scheduled on
        {conference_from_date && conference_to_date
          ? `${conference_from_date} - ${conference_to_date}`
          : `[Conference from and to Date]`}
        at {conference_location ? conference_location : '[Conference Venue]'}:
      </p>

      <ul>
        {journals && journals.length > 0 ? (
          journals.map((elem, index) => {
            const { journal_name } = elem;
            return (
              <li key={index}>
                {journal_name ? journal_name : `[Journal Name ${index + 1}]`}
              </li>
            );
          })
        ) : (
          <>
            <li>[Journal Name 1]</li>
            <li>[Journal Name 2]</li>
            <li>[Journal Name 3]</li>
          </>
        )}
      </ul>

      <p>
        In addition, the conference proceedings will be assigned the ISBN number{' '}
        <strong>{isbn_number ? isbn_number : `[ISBN Number]`}</strong>,
        providing further global recognition and enhancing the visibility of
        your work.
      </p>
      <p>
        <strong>Publication Opportunities:</strong>
      </p>
      <p>
        This is a valuable opportunity for your research to be evaluated and
        published in high-impact journals, boosting your academic profile and
        global reach.
      </p>
      <p>We look forward to your continued contribution to the field!</p>
    </div>
  );
};

export default ThirdStepWhatsappTemplate;
